import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "no-mb" }, "Heeft u de documentatie geraadpleegd? De antwoorden op veelgestelde vragen staan veelal ook in de documenten.", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h3", null, "Contactgegevens", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, "Onderstaande contactgegevens zullen worden gebruikt voor de behandeling van deze vraag. Pas aan indien nodig.", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Contactpersoon "),
  /*#__PURE__*/_createElementVNode("span", { class: "required-label" }, "*")
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Telefoonnummer "),
  /*#__PURE__*/_createElementVNode("span", { class: "required-label" }, "*")
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("E-mailadres "),
  /*#__PURE__*/_createElementVNode("span", { class: "required-label" }, "*")
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h3", null, "Details", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Categorie "),
  /*#__PURE__*/_createElementVNode("span", { class: "required-label" }, "*")
], -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Vraag "),
  /*#__PURE__*/_createElementVNode("span", { class: "required-label" }, "*")
], -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Omschrijving "),
  /*#__PURE__*/_createElementVNode("span", { class: "required-label" }, "*")
], -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", null, "Afbeeldingen", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("h3", null, [
  /*#__PURE__*/_createTextVNode("Voorwaarden "),
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f38929"} }, "*")
], -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", null, "Voor het oplossen van uw klacht is het noodzakelijk dat er een afspraak met u gemaakt wordt. Deze afspraak wordt gemaakt door de klacht oplossende onderaannemer of leverancier. Het is dan ook noodzakelijk dat u ons toestemming geeft voor de verstrekking van uw gegevens aan de klacht oplossende onderaannemer of leverancier.", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("a", {
  href: "/docs/Procedure_Nazorg.pdf",
  target: "_blank"
}, "procedure nazorg", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("a", {
  href: "/docs/Privacyverklaring_Thunnissen_Oktober_2019.pdf",
  target: "_blank"
}, "privacybeleid", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("Velden gemarkeerd met een "),
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f38929"} }, "*"),
  /*#__PURE__*/_createTextVNode(" zijn verplicht.")
], -1)

import { useRouter } from 'vue-router'
import { questionStore } from '@/stores/question'
import TextEditor from '@/components/service/TextEditor.vue'
import Uploader from '@/components/service/Uploader.vue'
import UploadQueue from '@/components/service/UploadQueue.vue'
import { computed, onMounted, ref } from 'vue'
import { authStore } from '@/stores/auth'
import { NewQuestion } from '@/types/service/question'
import { generalStore } from '@/stores/general'


export default /*#__PURE__*/_defineComponent({
  __name: 'QuestionCreate',
  setup(__props) {

const router = useRouter()
const question = ref<NewQuestion>({
  title: null,
  body: null,
  category: 0,
  contact_name: authStore().user.fullname ?? null,
  contact_phone: authStore().user.phonenumber ?? null,
  contact_email: authStore().user.email ?? null,
  files: [],
  type: 3
})

const agreeWithTerms = ref(false)

const requiredFieldsCompleted = computed(() => {
  return !!(question.value.title && question.value.body && question.value.contact_name && question.value.contact_email && question.value.contact_phone && agreeWithTerms.value)
})

onMounted(() => {
  question.value.building_id = authStore().selectedBuildingId
})

function newFileUploaded (file:File) : void {
  question.value.files.push(file)
}

function fileDeleted (index:number) : void {
  question.value.files.splice(index, 1)
}

return (_ctx: any,_cache: any) => {
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_row, { gutter: [16,16] }, {
    default: _withCtx(() => [
      (_unref(generalStore)().appSettings?.notification?.pages.includes('Service'))
        ? (_openBlock(), _createBlock(_component_a_col, {
            key: 0,
            xs: {span: 24},
            sm: {span: 24},
            md: {span: 24},
            lg: {span: 18, offset: 3}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_alert, {
                type: "info",
                class: "global-notification mb-16",
                message: _unref(generalStore)().appSettings.notification.title,
                "show-icon": ""
              }, {
                description: _withCtx(() => [
                  _createElementVNode("div", {
                    innerHTML: _unref(generalStore)().appSettings.notification.description
                  }, null, 8, _hoisted_1)
                ]),
                _: 1
              }, 8, ["message"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_a_col, {
        xs: {span: 24},
        sm: {span: 24},
        md: {span: 24},
        lg: {span: 18, offset: 3}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_card, { title: "Een nieuwe vraag stellen." }, {
            extra: _withCtx(() => [
              (_unref(generalStore)().desktop)
                ? (_openBlock(), _createBlock(_component_a_button, {
                    key: 0,
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push({ name: 'Questions' })))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Terug naar vragen")
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            default: _withCtx(() => [
              _createVNode(_component_a_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 24 }, {
                    default: _withCtx(() => [
                      _hoisted_2
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _hoisted_3,
              _hoisted_4,
              _createVNode(_component_a_row, { gutter: [16,16] }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, {
                    xs: {span: 24},
                    sm: {span: 24},
                    md: {span: 24},
                    lg: {span: 12}
                  }, {
                    default: _withCtx(() => [
                      _hoisted_5,
                      _createVNode(_component_a_input, {
                        type: "text",
                        value: question.value.contact_name,
                        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((question.value.contact_name) = $event))
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_row, { gutter: [16,16] }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, {
                    xs: {span: 24},
                    sm: {span: 24},
                    md: {span: 24},
                    lg: {span: 12}
                  }, {
                    default: _withCtx(() => [
                      _hoisted_6,
                      _createVNode(_component_a_input, {
                        type: "text",
                        value: question.value.contact_phone,
                        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((question.value.contact_phone) = $event))
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, {
                    xs: {span: 24},
                    sm: {span: 24},
                    md: {span: 24},
                    lg: {span: 12}
                  }, {
                    default: _withCtx(() => [
                      _hoisted_7,
                      _createVNode(_component_a_input, {
                        type: "text",
                        value: question.value.contact_email,
                        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((question.value.contact_email) = $event))
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_divider),
              _hoisted_8,
              _createVNode(_component_a_row, { gutter: [16,16] }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, {
                    xs: {span: 24},
                    sm: {span: 24},
                    md: {span: 24},
                    lg: {span: 12}
                  }, {
                    default: _withCtx(() => [
                      _hoisted_9,
                      _createVNode(_component_a_select, {
                        style: {"width":"100%"},
                        value: question.value.category,
                        "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((question.value.category) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_select_option, { value: 0 }, {
                            default: _withCtx(() => [
                              _createTextVNode("Algemeen")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_select_option, { value: 1 }, {
                            default: _withCtx(() => [
                              _createTextVNode("Facturatie")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["value"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_row, { gutter: [16,16] }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, {
                    xs: {span: 24},
                    sm: {span: 24},
                    md: {span: 24},
                    lg: {span: 12}
                  }, {
                    default: _withCtx(() => [
                      _hoisted_10,
                      _createVNode(_component_a_input, {
                        type: "text",
                        value: question.value.title,
                        "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((question.value.title) = $event))
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_row, { gutter: [16,16] }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 24 }, {
                    default: _withCtx(() => [
                      _hoisted_11,
                      _createVNode(TextEditor, {
                        content: question.value.body,
                        onContentChange: _cache[6] || (_cache[6] = ($event: any) => (question.value.body = $event))
                      }, null, 8, ["content"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_row, { gutter: [16,16] }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 24 }, {
                    default: _withCtx(() => [
                      _hoisted_12,
                      _createVNode(Uploader, { onNewFileUploaded: newFileUploaded }),
                      (question.value.files.length)
                        ? (_openBlock(), _createBlock(UploadQueue, {
                            key: 0,
                            "media-items": question.value.files,
                            onFileDeleted: fileDeleted
                          }, null, 8, ["media-items"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_divider),
              _hoisted_13,
              _hoisted_14,
              _createVNode(_component_a_row, { gutter: [16,16] }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 24 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_checkbox, {
                        disabled: _unref(authStore)().restricted(),
                        checked: agreeWithTerms.value,
                        onChange: _cache[7] || (_cache[7] = ($event: any) => (agreeWithTerms.value = !agreeWithTerms.value))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Ja ik ga akkoord met het doorgeven van mijn persoonsgegevens aan de klacht oplossende onderaannemer of leverancier, "),
                          _hoisted_15,
                          _createTextVNode(" & het "),
                          _hoisted_16,
                          _createTextVNode(".")
                        ]),
                        _: 1
                      }, 8, ["disabled", "checked"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_row, {
                class: "no-mb",
                gutter: [16,16]
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 24 }, {
                    default: _withCtx(() => [
                      _hoisted_17,
                      _createVNode(_component_a_button, {
                        type: "primary",
                        disabled: _unref(authStore)().restricted() || !_unref(requiredFieldsCompleted) || _unref(questionStore)().loading,
                        loading: _unref(questionStore)().loading,
                        onClick: _cache[8] || (_cache[8] = ($event: any) => (_unref(questionStore)().storeQuestion(question.value)))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Vraag versturen")
                        ]),
                        _: 1
                      }, 8, ["disabled", "loading"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})